const Error = () => {
    return (
       <div className="error">
           
               <h1>😵</h1>
               <h1 className="glitch">Error 404</h1> 
       
       </div>
    )
}

export default Error
